import React, { useEffect, useRef, useState } from 'react';

import { CustomChart } from '@components';
import { getElementAtEvent } from 'react-chartjs-2';
import { comma } from '@lib/utils';

const MsmtChartTemplate = () => {
  const chartRef = useRef();
  const image = new Image();
  image.src = 'https://www.nhis.or.kr/_res/nhis/nhis/img/images/health/figure/hdl_f_30.png';

  const plugin = [
    {
      beforeDraw: (chart) => {
        if (image.complete) {
          const { ctx } = chart;
          const { top, left, width, height } = chart.chartArea;
          ctx.drawImage(image, left, top + height / 2, width, height / 2);
        } else {
          image.onload = () => chart.draw();
        }
      },
    },
    // ChartDataLabels,
  ];
  const options = {
    layout: {
      padding: {
        top: 30,
      },
    },
    barPercentage: 0.1,
    scales: {
      xAxes: {
        // offset: true,
        type: 'linear',
        min: 0,
        max: 100,
        ticks: {
          callback: () => {
            return '';
          },
        },
      },
      yAxes: {
        max: 30,
        ticks: {
          callback: () => {
            return '';
          },
        },
      },
    },
    plugins: {
      tooltip: {
        intersect: false,
        enabled: false,
        yAlign: 'top',
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        color: 'black',
        align: 'end',
        anchor: 'start',
        font: {
          size: '10',
        },
        textAlign: 'center',
        // offset: -30,
        backgroundColor: 'white',
        borderRadius: 4,
        borderColor: 'red',
        borderWidth: 1,
        formatter(value, context) {
          return `${context.dataset.label}\n${context.dataset.data[0].x}`;
        },
      },
    },
  };

  // =======================================================================================================================================
  const [chartData, setChartData] = useState(); // 차트 데이터
  const [selIndex, setSelIndex] = useState(0); // 선택한 데이터의 인덱스
  const [width, setWidth] = useState(); // 차트 가로

  useEffect(() => {
    // webview 가 아닌 경우..
    if (!window.ReactNativeWebView) {
      setChartData({
        labels: [2010, 2011, 2012, 2013, 2015, 2017, 2018, 2019, 2020, 2021],
        datasets: [
          {
            label: '',
            data: [0, 19, 3, 5, 2, 3, 77, 2, 1, 6],
          },
        ],
      });

      setWidth(750);
    }
  }, []);

  const getChartDataFromRN = (param) => {
    setChartData(param);

    const { data } = param.datasets[0];
    setWidth(data.length * 75);
  };

  window.getChartDataFromRN = getChartDataFromRN;

  /**
   * 차트 옵션
   * @returns
   */
  const getChartOption = () => {
    let options = {
      hover: {
        mode: null,
      },
      elements: {
        point: {
          radius: 6,
          backgroundColor: '#32C5FF', // 데이터 포인트 색상
          borderWidth: [],
          borderColor: [],
        },
        line: {
          borderColor: 'rgba(50, 197, 255, 0.3)', // 라인 색상
          borderWidth: 7,
          tension: 0.5, // 곡선
        },
      },
      scales: {
        yAxes: {
          display: false,
          grid: {
            display: false,
            drawTicks: false,
          },
        },
        xAxes: {
          ticks: {
            color: [], // 라벨 색상
            padding: 10,
          },
          grid: {
            color: [], // 선택한 세로 선 색상
            lineWidth: 3,
            tickLength: 0,
          },
        },
      },
      responsive: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
    };

    const dataLength = chartData.datasets[0].data.length;

    // 선택한 데이터의 x축 라벨 색상
    const tickColorArray = new Array(dataLength).fill('#646464');
    tickColorArray[selIndex] = '#32C5FF';
    options.scales.xAxes.ticks.color = tickColorArray;

    // 선택한 데이터의 가로 선
    const gridColorArray = new Array(dataLength).fill('transparent');
    gridColorArray[selIndex] = 'rgba(50, 197, 255, 0.3)';
    options.scales.xAxes.grid.color = gridColorArray;

    // 선택한 데이터 포인트의 흰색 테두리
    const borderColorArray = new Array(dataLength).fill('#32C5FF');
    borderColorArray[selIndex] = '#F7AD00';
    options.elements.point.backgroundColor = borderColorArray;

    // 선택한 데이터 포인트의 크기
    // const borderWidthArray = new Array(dataLength).fill(0);
    // borderWidthArray[selIndex] = 5;
    // options.elements.point.borderWidth = borderWidthArray;

    return options;
  };

  /**
   * 데이터 클릭 이벤트
   * @param {*} event
   * @returns
   */
  const onClickDataPoint = (event) => {
    const context = getElementAtEvent(chartRef.current, event)[0]?.element.$context;

    // 점 이외 영역 클릭 시 오류 방지
    if (_.isUndefined(context)) {
      return;
    }

    const { index } = context;

    setSelIndex(index);

    // RN 으로 인덱스 변경 송신
    if (window.ReactNativeWebView) {
      ReactNativeWebView.postMessage(JSON.stringify({ selIndex: index }));
    }
  };

  const onMessageEvent = (e) => {
    e.stopPropagation();
    const { data } = e;
    const { type } = data;

    if (!_.includes(data, 'set') && !_.includes(type, 'webpack') && !_.includes(data, 'webpack')) {
      alert(data);
    }
  };

  useEffect(() => {
    if (window.ReactNativeWebView) {
      //   window.addEventListener('message', onMessageEvent, { capture: true });
    }
  }, []);

  return (
    <>
      {chartData?.datasets.length && (
        <div style={{ position: 'relative', backgroundColor: 'white' }}>
          <CustomChart
            type="bar"
            width={380}
            height={200}
            data={{
              labels: ' ',
              datasets: [
                {
                  label: '',
                  data: [_.max(chartData.datasets[0].data)],
                  backgroundColor: ['rgba(255, 255, 255, 0)'],
                  borderColor: ['rgba(255, 255, 255, 0)'],
                },
              ],
            }}
            options={{
              scales: {
                yAxes: {
                  position: 'right',
                  stacked: true,
                  ticks: {
                    beginAtZero: true,
                    count: 5,
                    callback: (e) => {
                      return comma(e);
                    },
                  },
                  grid: {
                    drawTicks: false,
                    display: true,
                    lineWidth: 1,
                    drawBorder: true,
                    borderColor: 'white',
                    color: 'rgba(209, 209, 209, 0.2)',
                  },
                },
                xAxes: {
                  grid: {
                    tickLength: 0,
                  },
                  ticks: {
                    padding: 10,
                  },
                },
              },
              responsive: false,
              plugins: {
                legend: {
                  display: false,
                },
                tooltip: {
                  enabled: false,
                },
              },
              animation: {
                onProgress: function (context) {
                  const { length } = document.getElementsByTagName('canvas');

                  //   document.getElementsByTagName('canvas')[0].style.zIndex = 10000;

                  //   document.getElementsByTagName('canvas')[length - 1].style.position = 'absolute';
                  //   document.getElementsByTagName('canvas')[length - 1].style.width = 500;
                  //   document.getElementsByTagName('canvas')[length - 1].style.height = 200;
                  //   document.getElementsByTagName('canvas')[length - 1].style.top = 0;
                  //   document.getElementsByTagName('canvas')[length - 1].style.left = 0;
                  //   document.getElementsByTagName('canvas')[length - 1].style.zIndex = 1;

                  //   const { ctx, chartArea } = context.chart;
                  //   const { left, top, width, height } = chartArea;

                  //   ctx.save();
                  //   ctx.strokeStyle = '#000';
                  //   ctx.borderWidth = 1;
                  //   //   ctx.borderStyle = options.borderDash;
                  //   // ctx.borderTopWidth = options.borderTopWidth
                  //   // ctx.setLineDash(options.borderDash || [])
                  //   // ctx.lineDashOffset = options.borderDashOffset
                  //   ctx.strokeRect(left, top, width, height);
                  //   ctx.restore();
                },
              },
            }}
          />
          <div style={{ width: '95%', overflowX: 'scroll', position: 'absolute', top: 0, left: 0 }}>
            <CustomChart type="line" ref={chartRef} height={200} width={width} data={chartData} options={getChartOption()} onClick={onClickDataPoint} />
          </div>
        </div>
      )}
    </>
  );
};

export default MsmtChartTemplate;
